import InitChunks from 'modules/InitChunks/InitChunks';
import ResponsiveService from 'shared/services/ResponsiveService';
import LazyLoad from 'vanilla-lazyload';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import getBreakpoint from '../shared/helpers/getBreakpoints';
import InputPasswordManager from '../components/InputPasswordManager/InputPasswordManager';
import InputValidityManager from '../components/InputValidityManager/InputValidityManager';
import BannerService from '../Services/Banner/BannerService';

/**
 * Abstract Class Page
 */
export default class Page {
  constructor() {
    if (this.constructor === Page) {
      throw new Error("Abstract classes can't be instantiated.");
    }

    // Load chunks in page
    new InitChunks();

    // Load style CSS for correct device
    new ResponsiveService();

    // Header
    new Header();

    // Footer
    new Footer();

    // Cookie
    Page.cookieMediaQuery();

    // Input Password
    new InputPasswordManager();

    // Check Input Validity
    new InputValidityManager();

    new BannerService();
  }

  /*
   * Set Media Query in Cookie
   * */
  private static cookieMediaQuery(): void {
    const key = 'media_query';
    const matchCookie = document.cookie.match(
      new RegExp(`(^| )${key}=([^;]+)`)
    );

    if (!matchCookie) {
      const date = new Date();
      const days = 1;
      const value = getBreakpoint;

      // Add Cookie 'first_time_loyalty'
      date.setTime(+date + days * 86400000); // 24 * 60 * 60 * 1000
      window.document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/`;
    }
  }

  /*
   * Add all images script in page
   * */
  private static images() {
    // LazyLoad
    const lazyLoadOptions = {};
    window.LAZY_LOAD = new LazyLoad(lazyLoadOptions);
  }
}
